import { constants, selectors } from 'modules/common';
import { isValidQBOVendorName } from 'pages/requestForm/selectors/qbooks/validationSelectors';
import { z } from 'zod';

import { messages } from './QBooksCounterpartyCreationPopupContent.messages';
import { AddressFieldId, FormFieldId } from './QBooksCounterpartyCreationPopupContent.types';

const { qBooksConstants } = constants;

const addressSchema = z.object({
    [AddressFieldId.street]: z.string(),
    [AddressFieldId.city]: z.string(),
    [AddressFieldId.postalCode]: z.string(),
    [AddressFieldId.country]: z.string(),
    [AddressFieldId.state]: z.string(),
});

const baseSchema = z.object({
    [FormFieldId.displayName]: z
        .string()
        .trim()
        .min(1, messages.requiredDisplayName)
        .max(
            qBooksConstants.DISPLAY_NAME_MAX_LENGTH,
            messages.displayNameLengthErrorText({
                length: qBooksConstants.DISPLAY_NAME_MAX_LENGTH,
            })
        )
        .refine(isValidQBOVendorName, messages.invalidDisplayNameErrorText)
        .refine((value) => !/\p{Extended_Pictographic}/u.test(value), messages.noEmojiInContactName),
    [FormFieldId.companyName]: z.string(),
    [FormFieldId.title]: z.string(),
    [FormFieldId.givenName]: z.string(),
    [FormFieldId.middleName]: z.string(),
    [FormFieldId.familyName]: z.string(),
    [FormFieldId.suffix]: z.string(),
    [FormFieldId.billingAddress]: addressSchema,
    [FormFieldId.email]: z.string().email().or(z.literal('')),
    [FormFieldId.primaryPhone]: z
        .string()
        .max(
            qBooksConstants.DISPLAY_NAME_MAX_LENGTH,
            messages.phoneLengthErrorText({
                length: qBooksConstants.PHONE_MAX_LENGTH,
            })
        )
        .refine(selectors.ui.isValidPhone, messages.invalidPhone)
        .or(z.literal('')),
    [FormFieldId.mobilePhone]: z
        .string()
        .max(
            qBooksConstants.DISPLAY_NAME_MAX_LENGTH,
            messages.mobileLengthErrorText({
                length: qBooksConstants.DISPLAY_NAME_MAX_LENGTH,
            })
        )
        .refine(selectors.ui.isValidPhone, messages.invalidMobile)
        .or(z.literal('')),
    [FormFieldId.fax]: z
        .string()
        .max(
            qBooksConstants.MOBILE_MAX_LENGTH,
            messages.faxNameLengthErrorText({
                length: qBooksConstants.FAX_MAX_LENGTH,
            })
        )
        .refine(selectors.ui.isValidPhone, messages.invalidFax)
        .or(z.literal('')),
    [FormFieldId.website]: z.string().refine(selectors.ui.isValidWebsite, messages.invalidWebsite).or(z.literal('')),

    [FormFieldId.currencyId]: z.string().optional().nullable(),
});

export const vendorSchema = baseSchema.extend({
    [FormFieldId.acctNum]: z.string(),
});

export const customerSchema = baseSchema.extend({
    [FormFieldId.shippingAddress]: addressSchema,
    [FormFieldId.sameAsBillingAddress]: z.boolean().optional(),
});

export const schema = vendorSchema.or(customerSchema);
